export var FacepileStyles = function FacepileStyles(props) {
  var theme = props.theme;
  var palette = theme.palette;
  return {
    overflowButton: {
      backgroundColor: palette.neutralLighter
    },
    descriptiveOverflowButton: {
      backgroundColor: palette.neutralLighter
    }
  };
};